import { createStore } from 'vuex';

export default createStore({
  state: {
    pathSource: "", //访问来源：直接访问，CRM，OBT
    pathQuery: {}, //URL查询信息
    listSearch:{
      listSearchModel:{},
      listSearchDataForm:{},
      searchParam:"",
      menuType:"",
      lang:"",
      token:"",
      isOpenBigOrder:"",
    },
  },
  mutations: {
    savePathSource(state, pathSource) {
      state.pathSource = pathSource;
    },
    changePathQuery(state, pathQuery) {
      state.pathQuery = pathQuery;
    },
  },
  actions: {},
  modules: {},
});